document.addEventListener('DOMContentLoaded', function () {


  // animation
  AOS.init({
    once: true
  });


});